export const showToast = (setToastMessage, setToastSeverity, setToastOpen, message, severity = 'info') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
};